import {Stack, Typography, useTheme} from "@mui/material";
import React, {useState} from "react";
import {validateEmail, validateRequired} from "../../components/formValidation/validators";
import ErrorHandlingForm from "../../components/formValidation/ErrorHandlingFrom";
import CustomTextField from "../../components/formValidation/CustomTextField";

const NewTourGuideData = ({reference, obj}) => {

    const theme = useTheme()
    const [formData, setFormData] = useState({
        first_name: '' || obj?.first_name,
        last_name: '' || obj?.last_name,
        phone: '' || obj?.phone,
        email: '' || obj?.email,
        tourguide_type: '' || obj?.tourguide_type
    })

    const [errors, setErrors] = useState({
        first_name: false,
        last_name: false,
        phone: false,
        email: false,
        tourguide_type: false
    })

    const validators = {
        first_name: [validateRequired],
        last_name: [validateRequired],
        phone: [],
        email: [validateRequired, validateEmail],
        tourguide_type: []
    }
    return <ErrorHandlingForm reference={reference} errors={errors} setErrors={setErrors} data={formData} setData={setFormData} validators={validators}>
        <Stack spacing={2}>
            <Typography variant='caption' color={theme.palette.primary[500]}>Keresztnév*</Typography>
            <CustomTextField
                data={formData}
                setData={setFormData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
                name="first_name"
                label='Keresztnév'/>
            <Typography variant='caption' color={theme.palette.primary[500]}>Vezetéknév*</Typography>
            <CustomTextField
                data={formData}
                setData={setFormData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
                name="last_name"
                label='Vezetéknév'/>
            <Typography variant='caption' color={theme.palette.primary[500]}>Telefonszám</Typography>
            <CustomTextField
                data={formData}
                setData={setFormData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
                name="phone"
                label='Telefonszám'/>
            <Typography variant='caption' color={theme.palette.primary[500]}>Email*</Typography>
            <CustomTextField
                data={formData}
                setData={setFormData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
                name="email"
                label='Email'/>
            <Typography variant='caption' color={theme.palette.primary[500]}>Típus</Typography>
            <CustomTextField
                data={formData}
                setData={setFormData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
                name="tourguide_type"
                label='Típus'/>

        </Stack>
    </ErrorHandlingForm>
}

export default NewTourGuideData